import {
  CreateCurrencyCommand,
  CurrencyDictionaryResponse_Int32,
  CurrencyTypeEnum,
  GetCurrencyResponse,
  PagedResponse_GetCurrencyResponse,
  UpdateCurrencyCommand,
} from '@acme/api';

export type CurrencyDictionaryResponse = CurrencyDictionaryResponse_Int32;

export type Currency = {
  /** Код/название валюты (например, RUB) */
  name: string;
  /** Символ валюты (например, ₽) */
  symbol: string;
};

export type PagedGetCurrencyResponse = PagedResponse_GetCurrencyResponse;
export type CurrencyResponse = GetCurrencyResponse;
export type AddCurrencyRequest = CreateCurrencyCommand & { mode: 'add' };
export type EditCurrencyRequest = UpdateCurrencyCommand & { mode: 'edit' };
export type CurrencyRequest = AddCurrencyRequest | EditCurrencyRequest;
export const ECurrencyTypeEnum = { ...CurrencyTypeEnum } as const;

export type CurrencyFilter = {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
};
